<script lang="ts" setup>
import VarsityInlineConfirm from "@/components/VarsityInlineConfirm.vue"
import VarsityInlineConfirmButton from "@/components/VarsityInlineConfirmButton.vue"
import { useLegacyHttpClient } from "@/composables/compat/useLegacyHttpClient"
import { createInlineConfirm } from "@/composables/createInlineConfirm"
import { injectMandatory, useModuleAction, type Entity, type ModuleConfiguration } from "@/vf"

const props = defineProps<{
    confirmTeleportTarget?: HTMLElement
}>()

const item = injectMandatory<Entity>("item", "item is required for VbDeleteButton")
const moduleAction = useModuleAction()

const config: ModuleConfiguration = injectMandatory("module-config", "module-config is required for VbDeleteButton")
const mode = config.show.page(item).mode

const inlineConfirm = createInlineConfirm({
    async action() {
        await useLegacyHttpClient().delete(config.entityPath(item))
    },
    afterAction() {
        moduleAction.executeAfterAction(config.afterDeleteAction, item, false, true)
    },
})
</script>

<template>
    <VarsityInlineConfirmButton
        class="btn btn-danger btn-shape-skewed btn-block btn-sm-inline-block"
        :controller="inlineConfirm"
        v-if="item?.id"
    >
        <i class="fa fa-fw fa-trash" v-if="mode === 'router'"></i>
        {{ $t("crud:button.delete") }}
    </VarsityInlineConfirmButton>

    <Teleport :to="props.confirmTeleportTarget" :disabled="!props.confirmTeleportTarget">
        <VarsityInlineConfirm :controller="inlineConfirm">
            <template #confirmation>
                {{
                    $t("crud:delete.confirmation_detail", {
                        type: $t(config.readableName.singular),
                        name: config.readableName.entity(item),
                    })
                }}
            </template>
            <template #success>
                {{
                    $t("crud:delete.success.message", {
                        type: $t(config.readableName.singular),
                        name: config.readableName.entity(item),
                        interpolation: { escapeValue: false },
                    })
                }}
            </template>
        </VarsityInlineConfirm>
    </Teleport>
</template>
